/**
 * May this caller read justifications at all?
 *
 * FOUR PERMISSIONS, NOT ONE, mirroring `JustificationPolicy::mayRead()` on
 * the server — the identical shape `src/lib/permissions/escalations.ts`'s
 * own docblock explains at length for `canReadEscalations`, restated here
 * because that file's history is exactly the risk this one guards against.
 *
 * Unlike `escalation.view` (directly grantable, NO role holds it), every
 * one of `justification.view`/`create`/`answer`/`decide` is a plain role
 * grant, and `RolePermissionSeeder::MATRIX` gives `justification.view` to
 * ALL FIVE roles today (spec §0/J-3 — everyone can be a subject). So this
 * helper is not fixing a feature nobody can reach; it exists so that a role
 * added later holding one of the other three permissions WITHOUT `view`
 * still reads — the exact educator/`escalation.act` defect M-10 shipped,
 * restated in `JustificationPolicy`'s own class docblock as the reason its
 * `mayRead()` admits four permissions rather than one.
 *
 * THIS IS THE ONLY PLACE THIS RULE MAY LIVE — imported by both the nav
 * gate (`App.tsx`) and this screen, never copied into either, the identical
 * discipline `canReadEscalations` documents. If the client and the server
 * (`JustificationPolicy::mayRead()`) ever disagree, the symptom is a nav
 * entry or panel that 403s, or a screen nobody can reach — so keep this
 * list in step with the server's.
 */
export function canReadJustifications(permissions: readonly string[]): boolean {
  return (
    permissions.includes('justification.view') ||
    permissions.includes('justification.create') ||
    permissions.includes('justification.answer') ||
    permissions.includes('justification.decide')
  );
}
